// ======================================
// API Client for NammaVeetuInteriors
// ======================================

const API_BASE_URL = window.location.hostname === 'localhost'
    ? 'http://localhost/backend/api'
    : '/backend/api';

/**
 * Demo mode mock data for local testing without PHP backend
 */
function getDemoData(endpoint, method = 'GET') {
    // For non-GET requests in demo mode, return success mock
    if (method !== 'GET') {
        console.warn(`⚠️ DEMO MODE: Simulated ${method} for ${endpoint}`);
        alert(`✅ Demo Mode: ${method} operation simulated successfully!\nNote: Changes are not persisted in demo mode.`);
        return { success: true, data: { id: Date.now(), message: 'Demo mode - operation simulated' } };
    }

    const demoLeads = [
        { id: 1, name: 'Rajesh Kumar', phone: '+919876543210', email: 'rajesh@gmail.com', property_type: '3bhk', budget_range: '10-15L', source: 'website', status: 'new', location: 'Chennai', created_at: '2026-02-10', notes: '' },
        { id: 2, name: 'Priya Sharma', phone: '+919876543211', email: 'priya@gmail.com', property_type: '2bhk', budget_range: '5-10L', source: 'referral', status: 'contacted', location: 'Bangalore', created_at: '2026-02-09', notes: 'Interested in modular kitchen' },
        { id: 3, name: 'Arvind Menon', phone: '+919876543212', email: 'arvind@gmail.com', property_type: 'villa', budget_range: '20-30L', source: 'google', status: 'qualified', location: 'Coimbatore', created_at: '2026-02-08', notes: '' },
        { id: 4, name: 'Lakshmi Devi', phone: '+919876543213', email: 'lakshmi@gmail.com', property_type: '3bhk', budget_range: '15-20L', source: 'instagram', status: 'proposal_sent', location: 'Chennai', created_at: '2026-02-07', notes: '' },
        { id: 5, name: 'Suresh Babu', phone: '+919876543214', email: 'suresh@gmail.com', property_type: '1bhk', budget_range: '3-5L', source: 'website', status: 'won', location: 'Hyderabad', created_at: '2026-02-05', notes: 'Converted to project' },
    ];
    const demoProjects = [
        { id: 1, title: 'Modern Kitchen - Anna Nagar', customer_name: 'Suresh Babu', customer_email: 'suresh@gmail.com', customer_phone: '+919876543214', property_type: '3BHK', city: 'Chennai', address: '42, Anna Nagar 2nd Street', pincode: '600040', status: 'designing', total_amount: 450000, paid_amount: 180000, designer_name: 'Designer Priya', milestones: [{ title: 'Site Visit', completed_at: '2026-01-15' }, { title: 'Design Approval', completed_at: '2026-01-28' }, { title: 'Manufacturing', completed_at: null }, { title: 'Installation', completed_at: null }], files: [{ file_name: 'kitchen_3d_render.pdf', file_type: 'PDF', file_url: '#', created_at: '2026-01-28' }] },
        { id: 2, title: 'Full Home Interior - Velachery', customer_name: 'Rajesh Kumar', customer_email: 'rajesh@gmail.com', customer_phone: '+919876543210', property_type: '2BHK', city: 'Chennai', address: '18, Velachery Main Road', pincode: '600042', status: 'manufacturing', total_amount: 1200000, paid_amount: 600000, designer_name: 'Designer Arun', milestones: [{ title: 'Site Visit', completed_at: '2026-01-05' }, { title: 'Design Approval', completed_at: '2026-01-18' }, { title: 'Manufacturing', completed_at: null }, { title: 'Installation', completed_at: null }], files: [] },
        { id: 3, title: 'Wardrobe Set - Adyar', customer_name: 'Priya Sharma', customer_email: 'priya@gmail.com', customer_phone: '+919876543211', property_type: '3BHK', city: 'Chennai', address: '7, Adyar Park Road', pincode: '600020', status: 'completed', total_amount: 280000, paid_amount: 280000, designer_name: 'Designer Priya', milestones: [{ title: 'Site Visit', completed_at: '2025-12-10' }, { title: 'Design Approval', completed_at: '2025-12-20' }, { title: 'Manufacturing', completed_at: '2026-01-10' }, { title: 'Installation', completed_at: '2026-01-20' }], files: [] },
    ];
    const demoRates = [
        { id: 1, city: 'Chennai', category: 'modular_kitchen', item_name: 'Base Cabinets', unit: 'sq.ft', rate_per_unit: 1250, is_active: 1, description: 'Marine plywood with laminate finish' },
        { id: 2, city: 'Chennai', category: 'modular_kitchen', item_name: 'Wall Cabinets', unit: 'sq.ft', rate_per_unit: 1100, is_active: 1, description: 'MDF with acrylic finish' },
        { id: 3, city: 'Chennai', category: 'wardrobe', item_name: 'Sliding Wardrobe', unit: 'sq.ft', rate_per_unit: 950, is_active: 1, description: '?"S3 grade plywood with soft-close' },
        { id: 4, city: 'Bangalore', category: 'modular_kitchen', item_name: 'Base Cabinets', unit: 'sq.ft', rate_per_unit: 1400, is_active: 1, description: 'BWR plywood with PU finish' },
        { id: 5, city: 'Bangalore', category: 'flooring', item_name: 'Vitrified Tiles', unit: 'sq.ft', rate_per_unit: 85, is_active: 1, description: '600x600 polished tiles' },
        { id: 6, city: 'Coimbatore', category: 'painting', item_name: 'Interior Emulsion', unit: 'sq.ft', rate_per_unit: 28, is_active: 1, description: 'Asian Paints Royale' },
    ];
    const demoBlogPosts = [
        { id: 1, title: '10 Modern Kitchen Design Ideas for 2026', slug: 'modern-kitchen-design-2026', category: 'kitchen', status: 'published', excerpt: 'Explore the latest trends...', featured_image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400', views: 245, created_at: '2026-02-01', tags: ['kitchen', 'modern', 'trends'] },
        { id: 2, title: 'How to Choose the Perfect Wardrobe', slug: 'perfect-wardrobe-guide', category: 'bedroom', status: 'published', excerpt: 'A complete guide...', featured_image: 'https://images.unsplash.com/photo-1558618666-fcd25c85f82e?w=400', views: 189, created_at: '2026-01-20', tags: ['wardrobe', 'bedroom', 'guide'] },
        { id: 3, title: 'Budget-Friendly Interior Design Tips', slug: 'budget-interior-tips', category: 'tips', status: 'draft', excerpt: 'Design your dream home...', featured_image: null, views: 0, created_at: '2026-02-08', tags: ['budget', 'tips'] },
    ];

    const demoServices = [
        { id: 1, title: 'Modular Kitchen', slug: 'modular-kitchen', price_range: '₹1.5L - ₹8L', timeline: '30-45 Days', image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400', description: 'Modern, functional modular kitchens.', highlights: ['BWP Plywood', 'Soft-close', '5 Year Warranty'] },
        { id: 2, title: 'Full Home Interior', slug: 'full-home-interior', price_range: '₹8L - ₹25L', timeline: '60-90 Days', image: 'https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?w=400', description: 'Complete interior solutions for your home.', highlights: ['Space Planning', '3D Design', 'Turnkey Execution'] },
        { id: 3, title: 'Wardrobe Design', slug: 'wardrobe-design', price_range: '₹40k - ₹1.5L', timeline: '20-30 Days', image: 'https://images.unsplash.com/photo-1558618666-fcd25c85f82e?w=400', description: 'Custom wardrobes for your bedroom.', highlights: ['Sliding Doors', 'Loft Storage', 'Internal Organizers'] }
    ];

    const demoLocations = [
        { id: 1, slug: 'chennai', name: 'Chennai', project_count: 350, areas: ['Anna Nagar', 'T. Nagar', 'Velachery', 'OMR'], image: 'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=400' },
        { id: 2, slug: 'coimbatore', name: 'Coimbatore', project_count: 85, areas: ['RS Puram', 'Gandhipuram'], image: 'https://images.unsplash.com/photo-1570168007204-dfb528c6958f?w=400' },
        { id: 3, slug: 'bangalore', name: 'Bangalore', project_count: 120, areas: ['Whitefield', 'Indiranagar'], image: 'https://images.unsplash.com/photo-1596176530529-78163a4f7af2?w=400' }
    ];

    const demoTeam = [
        { id: 1, name: 'Arun Kumar', role: 'Founder & Lead Designer', bio: '15+ years experience', image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=300' },
        { id: 2, name: 'Priya Venkatesh', role: 'Creative Director', bio: 'Expert in fusion designs', image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=300' }
    ];

    const demoPortfolio = [
        { id: 1, title: 'Modern Minimalist Home', slug: 'modern-minimalist', category: '3bhk', city: 'Chennai', featured_image: 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=600', budget_range: '₹12L', area_sqft: 1200, duration_days: 45 },
        { id: 2, title: 'Luxury Villa', slug: 'luxury-villa', category: 'villa', city: 'Coimbatore', featured_image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=600', budget_range: '₹28L', area_sqft: 3500, duration_days: 75 }
    ];

    // Match endpoint patterns
    const ep = endpoint.split('?')[0]; // strip query params

    if (ep === '/dashboard/stats') return { success: true, data: { new_leads: 12, active_projects: 5, pending_inquiries: 8, revenue_this_month: 450000 } };
    if (ep === '/dashboard/recent-leads') return { success: true, data: demoLeads.slice(0, 5) };
    if (ep === '/dashboard/recent-projects') return { success: true, data: demoProjects };
    if (ep === '/leads') return { success: true, data: demoLeads };
    if (ep.match(/^\/leads\/\d+$/)) return { success: true, data: demoLeads[0] };
    if (ep === '/projects') return { success: true, data: demoProjects };
    if (ep.match(/^\/projects\/\d+$/)) { const id = parseInt(ep.split('/')[2]); return { success: true, data: demoProjects.find(p => p.id === id) || demoProjects[0] }; }
    if (ep === '/services') return { success: true, data: demoServices };
    if (ep.match(/^\/services\//)) { const slug = ep.split('/')[2]; return { success: true, data: demoServices.find(s => s.slug === slug || s.id == slug) || demoServices[0] }; }
    if (ep === '/pricing') return { success: true, data: demoRates };
    if (ep.startsWith('/blog')) return { success: true, data: { posts: demoBlogPosts }, posts: demoBlogPosts };
    if (ep === '/portfolio') return { success: true, data: demoPortfolio };
    if (ep.match(/^\/portfolio\//)) { const slug = ep.split('/')[2]; return { success: true, data: demoPortfolio.find(p => p.slug === slug || p.id == slug) || demoPortfolio[0] }; }
    if (ep === '/locations') return { success: true, data: demoLocations };
    if (ep.match(/^\/locations\//)) { const slug = ep.split('/')[2]; return { success: true, data: demoLocations.find(l => l.slug === slug) || demoLocations[0] }; }
    if (ep === '/team') return { success: true, data: demoTeam };
    if (ep === '/analytics') return { success: true, data: { summary: { total_events: 1250, unique_pages: 18, top_source: 'Google' }, top_pages: [{ page: '/', views: 520 }, { page: '/services', views: 340 }, { page: '/contact', views: 210 }, { page: '/estimator', views: 180 }], lead_sources: [{ source: 'website', count: 25 }, { source: 'google', count: 18 }, { source: 'referral', count: 12 }, { source: 'instagram', count: 8 }], recent_events: [{ event_type: 'page_view', page_url: '/', created_at: '2026-02-10 14:30:00' }, { event_type: 'lead_submit', page_url: '/contact', created_at: '2026-02-10 12:15:00' }] } };
    if (ep === '/referrals') return { success: true, data: [{ id: 1, referrer_name: 'Suresh B', referee_name: 'Karthik R', status: 'pending', reward_amount: 5000, created_at: '2026-02-08' }, { id: 2, referrer_name: 'Priya S', referee_name: 'Meena K', status: 'converted', reward_amount: 5000, created_at: '2026-01-25' }] };
    if (ep === '/users') return { success: true, data: [{ id: 1, name: 'Admin User', email: 'admin@nammaveetuinteriors.com', role: 'admin', is_active: 1 }, { id: 2, name: 'Designer Priya', email: 'priya@nvi.com', role: 'designer', is_active: 1 }] };
    if (ep === '/inquiries') return { success: true, data: [] };
    if (ep === '/consultations') return { success: true, data: [] };

    return { success: true, data: [] };
}


/**
 * Make an API request
 * @param {string} endpoint - API endpoint (e.g., '/leads')
 * @param {object} options - Fetch options
 * @returns {Promise<object>} - Response data
 */
export async function apiRequest(endpoint, options = {}) {
    const token = localStorage.getItem('nvi_token');

    const headers = {
        'Content-Type': 'application/json',
        ...options.headers
    };

    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    const config = {
        ...options,
        headers
    };

    // Handle body serialization
    if (config.body && typeof config.body === 'object') {
        config.body = JSON.stringify(config.body);
    }

    try {
        const response = await fetch(`${API_BASE_URL}${endpoint}`, config);
        const data = await response.json();

        if (!response.ok) {
            if (response.status === 401) {
                localStorage.removeItem('nvi_token');
                localStorage.removeItem('nvi_user');

                // Only redirect to login if on protected route
                const currentPath = window.location.pathname;
                const protectedPrefixes = ['/admin', '/dashboard', '/my-', '/profile'];
                const isProtected = protectedPrefixes.some(p => currentPath.startsWith(p));

                if (isProtected) {
                    window.location.href = '/login';
                } else {
                    // For public pages, just reload to refresh UI state (logged out view)
                    window.location.reload();
                }
            }
            throw new Error(data.error || `API Error: ${response.status}`);
        }

        return data;
    } catch (error) {
        // Demo mode: return mock data when backend is unreachable on localhost
        if (window.location.hostname === 'localhost' &&
            (error.message === 'Failed to fetch' || error.message.includes('NetworkError'))) {
            console.warn(`⚠️ DEMO MODE: Mock response for ${endpoint}`);
            return getDemoData(endpoint, options.method || 'GET');
        }
        console.error('API Request failed:', error);
        throw error;
    }
}

/**
 * GET request
 */
export function get(endpoint, params = {}) {
    const queryString = new URLSearchParams(params).toString();
    const url = queryString ? `${endpoint}?${queryString}` : endpoint;
    return apiRequest(url, { method: 'GET' });
}

/**
 * POST request
 */
export function post(endpoint, data) {
    return apiRequest(endpoint, {
        method: 'POST',
        body: JSON.stringify(data)
    });
}

/**
 * PUT request
 */
export function put(endpoint, data) {
    return apiRequest(endpoint, {
        method: 'PUT',
        body: JSON.stringify(data)
    });
}

/**
 * DELETE request
 */
export function del(endpoint) {
    return apiRequest(endpoint, { method: 'DELETE' });
}

// ======================================
// API Endpoints
// ======================================

// Auth
export const authAPI = {
    login: (email, password) => post('/auth/login', { email, password }),
    register: (data) => post('/auth/register', data),
    me: () => get('/auth/me'),
    updateProfile: (data) => put('/auth/update-profile', data),
    changePassword: (data) => post('/auth/change-password', data)
};

// Leads
export const leadsAPI = {
    list: (params = {}) => get('/leads', params),
    get: (id) => get(`/leads/${id}`),
    create: (data) => post('/leads', data),
    update: (id, data) => put(`/leads/${id}`, data),
    delete: (id) => del(`/leads/${id}`)
};

// Inquiries (Contact Form)
export const inquiriesAPI = {
    list: (params = {}) => get('/inquiries', params),
    create: (data) => post('/inquiries', data),
    update: (id, data) => put(`/inquiries/${id}`, data)
};

// Projects
export const projectsAPI = {
    list: (params = {}) => get('/projects', params),
    get: (id) => get(`/projects/${id}`),
    create: (data) => post('/projects', data),
    update: (id, data) => put(`/projects/${id}`, data)
};

// Quotes
export const quotesAPI = {
    list: () => get('/quotes'),
    create: (data) => post('/quotes', data)
};

// Consultations
export const consultationsAPI = {
    list: () => get('/consultations'),
    create: (data) => post('/consultations', data),
    update: (id, data) => put(`/consultations/${id}`, data)
};

// Users (Admin)
export const usersAPI = {
    list: (params = {}) => get('/users', params),
    get: (id) => get(`/users/${id}`),
    create: (data) => post('/users', data),
    update: (id, data) => put(`/users/${id}`, data)
};

// Services (Admin + Public)
export const servicesAPI = {
    list: (params = {}) => get('/services', params),
    get: (id) => get(`/services/${id}`),
    create: (data) => post('/services', data),
    update: (id, data) => put(`/services/${id}`, data),
    delete: (id) => del(`/services/${id}`)
};

// About Page
export const aboutAPI = {
    get: () => get('/about'),
    update: (data) => put('/about', data)
};

// File Upload
export const uploadAPI = {
    upload: (file) => {
        const formData = new FormData();
        formData.append('file', file);
        return apiRequest('/upload', {
            method: 'POST',
            body: formData
        });
    }
};

// Dashboard
export const dashboardAPI = {
    stats: () => get('/dashboard/stats'),
    recentLeads: () => get('/dashboard/recent-leads'),
    recentProjects: () => get('/dashboard/recent-projects')
};

// Packages
export const packagesAPI = {
    list: () => get('/packages'),
    get: (id) => get(`/packages/${id}`),
    create: (data) => post('/packages', data),
    update: (id, data) => put(`/packages/${id}`, data),
    delete: (id) => del(`/packages/${id}`)
};

// Articles (Blog)
export const articlesAPI = {
    list: (params = {}) => get('/articles', params),
    get: (idOrSlug) => get(`/articles/${idOrSlug}`),
    create: (data) => post('/articles', data),
    update: (id, data) => put(`/articles/${id}`, data),
    delete: (id) => del(`/articles/${id}`)
};

// Blog (New)
export const blogAPI = {
    list: (params = {}) => get('/blog', params),
    get: (idOrSlug) => get(`/blog/${idOrSlug}`),
    create: (data) => post('/blog', data),
    update: (id, data) => put(`/blog/${id}`, data),
    delete: (id) => del(`/blog/${id}`)
};

// Portfolio
export const portfolioAPI = {
    list: (params = {}) => get('/portfolio', params),
    get: (idOrSlug) => get(`/portfolio/${idOrSlug}`),
    create: (data) => post('/portfolio', data),
    update: (id, data) => put(`/portfolio/${id}`, data),
    delete: (id) => del(`/portfolio/${id}`)
};

// Locations
export const locationsAPI = {
    list: () => get('/locations'),
    get: (slug) => get(`/locations/${slug}`),
    create: (data) => post('/locations', data),
    update: (id, data) => put(`/locations/${id}`, data),
    delete: (id) => del(`/locations/${id}`)
};

// Team
export const teamAPI = {
    list: () => get('/team'),
    create: (data) => post('/team', data),
    update: (id, data) => put(`/team/${id}`, data),
    delete: (id) => del(`/team/${id}`)
};

// Design Ideas
export const designIdeasAPI = {
    list: (params = {}) => get('/design-ideas', params),
    get: (id) => get(`/design-ideas/${id}`),
    create: (data) => post('/design-ideas', data),
    update: (id, data) => put(`/design-ideas/${id}`, data),
    delete: (id) => del(`/design-ideas/${id}`)
};

// Referrals
export const referralsAPI = {
    list: () => get('/referrals'),
    create: (data) => post('/referrals', data)
};

// Testimonials
export const testimonialsAPI = {
    list: (params = {}) => get('/testimonials', params),
    create: (data) => post('/testimonials', data),
    update: (id, data) => put(`/testimonials/${id}`, data),
    delete: (id) => del(`/testimonials/${id}`)
};

// Analytics
export const analyticsAPI = {
    track: (data) => post('/analytics', data),
    get: (params = {}) => get('/analytics', params)
};
